import ticketSingle from "../../assets/png/ticket_single.png";
import tlicon from "../../assets/svg/tlicon.svg";
import { ReactSVG } from "react-svg";

const TicketCard = ({
  discountPercentage,
  ticketAmount,
  price,
  p_labnel,
  price_text,
  bonusPercentage,
  productClicked,
  icon,
}) => {
  return (
    <div className="w-[155px] md:w-[190px] mt-[62px] md:mt-[45px]">
      <div className="bg-stadeo-green h-[265px] md:h-[277px] rounded-[14px] md:rounded-[18px] text-center relative ">
        {icon ? (
          <div className="pt-[19px] md:pt-[23px] relative h-[75px] md:h-[105px]">
            <div className="absolute md:bottom-[10px] md:left-[52%] bottom-[-10px] left-[52%] translate-x-[-55%] top-[6px]">
              <ReactSVG className="md:scale-[1.9] scale-[1.8]" src={icon} />
            </div>
          </div>
        ) : (
          <div className="pt-[19px] md:pt-[38.5px] h-[75px] md:h-[105px] ">
            <img
              className="m-auto w-[45px] md:w-[55px]"
              src={ticketSingle}
              alt=""
            />
          </div>
        )}

        {bonusPercentage ? (
          <>
            <ReactSVG
              className="absolute top-[6.5px] left-[5.5px] md:top-[10.5px] md:left-[9.5px] scale-[1.25] md:scale-[1.4]"
              src={tlicon}
            />
            <div className="absolute top-[6px] left-[3px] md:left-[5px] text-white">
              <p className="font-semibold text-[8px] md:text-[9px]">
                DISCOUNT
              </p>
              <p className="font-bold text-[16px] mt-[-5px]">
                -{bonusPercentage}
              </p>
            </div>
          </>
        ) : null}

        <p className="text-[25px] md:text-[30px] font-worksans font-semibold mt-[72px] md:mt-[50px]">
          {ticketAmount}
        </p>
        <p className="text-[21px] scale-[calc(7.9_/_12)] font-worksans leading-[12px] md:text-[18px] md:scale-[calc(10_/_12)]">
          tickets
        </p>
        <div className="mt-[15px] md:mt-[14px] bg-stadeo-bold-green h-[36px] md:h-[35px] w-[134px] md:w-[150px] m-auto rounded-[20px] md:rounded-[20px] flex items-center justify-center">
          <p
            className="text-[19px] scale-[calc(10_/_12)]  md:text-[19px] text-white font-semibold  cursor-pointer"
            onClick={() => {
              productClicked();
            }}
          >
           {price_text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TicketCard;
